// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"386":"faqs","406":"newlist"}[chunkId] + "." + {"386":"013fb4fa","406":"98b674e1"}[chunkId] + ".js";
};